/**
 * 姓名联系方式
 */
// export default function nameAndPhone({
//     name = '',
//     phone = '',
// }) {
//     if (!name && !phone) return '--';
//     return `${name || ''} ${phone || ''}`;
// }

export default function nameAndPhone({
    name = '',
    phone = '',
}, empty = '', separator = ' ') {
    if (!name && !phone) return empty;
    return Object.values({ name, phone }).join(separator).trim();
}
